// extracted by mini-css-extract-plugin
export default {"melodyVideo":"eN-z","isFullWidth":"fN-z","landingPageVideo":"gN-z","play":"hN-z","iframeVideo":"iN-z","playHidden":"jN-z","fullwidth":"kN-z"};